import { createGateways } from '@ankr.com/auth';

import { IS_PROD } from 'modules/common/constants/env';

const AUTH_APP_PATH_PROD = 'ankr.com/rpc/auth/';
const host = window.location.host;
const AUTH_APP_PATH_STAGE =
  host && !host.includes('localhost')
    ? `${host}/rpc/auth/`
    : 'www-stage.ankr.com/rpc/auth/';

export const AUTH_APP_PATH = IS_PROD ? AUTH_APP_PATH_PROD : AUTH_APP_PATH_STAGE;
export const AUTH_APP_ID = 'MultiRPC';

const AUTH_PATH_STAGE = 'https://stage-auth.ankr.com/';
const AUTH_PATH_PROD = 'https://auth.ankr.com/';

export const AUTH_PATH = IS_PROD ? AUTH_PATH_PROD : AUTH_PATH_STAGE;

export const APIGateways = createGateways({ baseURL: '' });

export const SIGN_OUT_CACHE_KEY = 'signOut-cache-key';
